import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10 7L9.484 8.394C8.808 10.222 8.47 11.136 7.803 11.803C7.136 12.47 6.222 12.808 4.394 13.484L3 14L4.394 14.516C6.222 15.192 7.136 15.531 7.803 16.197C8.47 16.863 8.808 17.778 9.484 19.606L10 21L10.516 19.606C11.192 17.778 11.531 16.864 12.197 16.197C12.863 15.53 13.778 15.192 15.606 14.516L17 14L15.606 13.484C13.778 12.808 12.864 12.47 12.197 11.803C11.53 11.136 11.192 10.222 10.516 8.394L10 7ZM18 3L17.779 3.597C17.489 4.381 17.344 4.773 17.059 5.058C16.773 5.344 16.381 5.489 15.597 5.778L15 6L15.598 6.221C16.381 6.511 16.773 6.656 17.058 6.941C17.344 7.227 17.489 7.619 17.778 8.403L18 9L18.221 8.403C18.511 7.619 18.656 7.227 18.941 6.942C19.227 6.656 19.619 6.511 20.403 6.222L21 6L20.402 5.779C19.619 5.489 19.227 5.344 18.942 5.059C18.656 4.773 18.511 4.381 18.222 3.597L18 3Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }